<template>
  <vf-link
    class="flex items-center gap-1 "
    :class="[presets?.[content.menuStyle!], { [brandClasses.featured]: l2?.featured }]"
    :target="content.target?.targetAttribute"
    :to="content.target?.url"
    variant="quieter"
    @click="$emit('click')"
  >
    <vf-icon v-if="content.menuIcon" :name="content.menuIcon.icon" size="xs" />
    <span v-if="showTitleHtml" v-html="content.titleHtml" />
    <span v-else>{{ content.title }}</span>
  </vf-link>
</template>

<script lang="ts" setup>
import type { MenuItem } from '#types/components/cms/mega-menu'
import { MegaMenuL2ContextKey } from '#content/contexts/megamenu'

defineProps<{
  content: MenuItem
}>()

defineEmits<{
  click: []
}>()

const { showTitleHtml } = useFeatureFlags()
const { brandClasses, presets } = useAppConfig().components.cms.megaMenuL3Desktop

const l2 = inject(MegaMenuL2ContextKey)
</script>
